<div class="modules">
  <div class="modules-header">
    <app-button class="back-button" theme="info" text="<< Retour" size="xs" [outlined]="true" (onClick)="navigateToELearning()"></app-button>
    <span class="title">Modules</span>
  </div>
  <div class="content" *ngIf="selectedModule; else loading">
    <div id="module-thumbnails" class="thumbnails">
      <ng-container *ngFor="let module of masterclass.modules">
        <app-module-thumbnail
          [module]="module"
          [isSelected]="module.id === selectedModule.id"
          [disabled]="!module.isAvailableInDemo && !isVisualize && (demo || !masterclass.isObtained)"
          (click)="onThumbnailClick(module)"
        ></app-module-thumbnail>
      </ng-container>

      <div
        *ngIf="deliverableModulesCount > 0 && !isVisualize && !demo"
        class="deliverable-card"
        [class.complete]="isDeliverableComplete"
        (click)="goToDeliverableRecap()"
      >
        <div class="deliverable-icon">
          <span *ngIf="!isDeliverableComplete">📄</span>
          <span *ngIf="isDeliverableComplete">✅</span>
        </div>
        <div class="deliverable-info">
          <span class="deliverable-title">Mon livrable final</span>
          <span class="deliverable-progress">{{ deliverableAnsweredCount }} / {{ deliverableModulesCount }} complétés</span>
        </div>
        <div class="deliverable-arrow">→</div>
      </div>
    </div>
    <div *ngIf="innerWidth > 768" class="splitting-bar"></div>
    <div class="details">
      <app-module-overview
        *ngIf="innerWidth > 768 || isModuleOverviewOpen"
        [module]="selectedModule"
        [masterclass]="masterclass"
        [loadingProgress]="loadingProgress"
        [isVisualize]="isVisualize"
        (goToModule)="onModuleClick($event)"
        (goToBuyMasterclass)="buyMasterclass($event)"
        (closeModuleOverview)="closeModuleOverview()"
      ></app-module-overview>
    </div>
  </div>
</div>

<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
